<!-- 
		定时任务信息
		jay 2020-01-09
 -->
<template>
  <div class="voluntarily-info">
    <div class="switch-box">
      <div class="switch-top">
        <span>
          {{ switchFlag ? $t("recharge.open") : $t("recharge.close") }}
        </span>
        <i-switch :value="switchFlag" @on-change="changeSwitch"></i-switch>
      </div>
      <p>
        {{ $t("recharge.openTips") }}
      </p>
    </div>
    <div class="alway-day">
      <div class="alway-day-title">
        <span>{{ $t("recharge.dateSelection") }}</span>
      </div>
      <div class="alway-day-choose">
        <span>{{ $t("recharge.rechargeDate") }}</span>
        <Icon type="md-calendar" @click="openDate" />
        <span class="day" @click="openDate">
          {{
            thisDay == 0
              ? $t("recharge.lastDayOfEveryMonth")
              : language == "en"
              ? thisDay +
                (thisDay == 1
                  ? "st"
                  : thisDay == 2
                  ? "nd"
                  : thisDay == 3
                  ? "rd"
                  : "th") +
                $t("recharge.everyMonth")
              : $t("recharge.everyMonth") + thisDay + $t("common.days")
          }}
        </span>
        <div class="date-list" v-if="selectDateFlag">
          <ul>
            <li v-for="(item, index) in 28" :key="index">
              <a
                :class="{
                  active: thisDay == item,
                  fei: item == 29 || item == 30 || item == 31
                }"
                @click="setDay(item)"
              >
                {{ item }}
              </a>
            </li>
            <li class="last-day" @click="setLastDay">
              <a :class="{ active: thisDay == 0 }">
                {{ $t("recharge.lastDayOfEveryMonth") }}
              </a>
            </li>

            <li class="placeholder-li"></li>
            <li class="placeholder-li"></li>
            <li class="placeholder-li"></li>
            <li class="placeholder-li"></li>
            <li class="placeholder-li"></li>
            <li class="placeholder-li"></li>
            <li class="placeholder-li"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    selectDateFlag: {
      // 设置任务时间Flag
      type: Boolean,
      default: false
    },
    thisDay: {
      // 选中天数
      type: Number,
      default: 0
    },
    switchFlag: {
      // 开启关闭Flag
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateFlag: false,
      loadSubmit: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    changeSwitch(val) {
      // 改变开关
      this.$emit("update:switchFlag", val);
    },
    openDate(e) {
      // 开启日期
      let vm = this;
      vm.$emit("update:selectDateFlag", vm.selectDateFlag ? false : true);
      e.stopPropagation();
    },
    setLastDay() {
      //选择这个月的最后一天
      let vm = this;
      vm.$emit("update:thisDay", 0);
      vm.$emit("update:selectDateFlag", false);
    },
    setDay(day) {
      //设置日期
      let vm = this;
      if (day == 29 || day == 30 || day == 31) {
        return;
      }
      vm.$emit("update:thisDay", day);
      vm.$emit("update:selectDateFlag", false);
    }
  },
  components: {},
  watch: {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.voluntarily-info {
  margin-top: 20px;
  margin-bottom: 20px;
  .switch-box {
    .switch-top {
      color: #4a4a4a;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      /deep/.ivu-switch-checked {
        border-color: #2042ab;
        background-color: #2042ab;
      }
    }
    p {
      margin-top: 8px;
      line-height: 18px;
      color: #666;
      font-size: 12px;
    }
  }
  .alway-day {
    color: #4a4a4a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    margin-top: 16px;
    .alway-day-title {
      display: flex;
      align-items: center;
    }
    .alway-day-choose {
      display: flex;
      align-items: center;
      position: relative;
      /deep/.ivu-icon {
        font-size: 18px;
        color: #2042ab;
        margin-left: 8px;
        vertical-align: middle;
        cursor: pointer;
      }
      .day {
        display: inline-block;
        width: 150px;
        height: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 5px;
        border: 1px solid rgba(204, 204, 204, 1);
        margin-left: 10px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }
      .date-list {
        position: absolute;
        width: 280px;
        z-index: 10;
        padding: 20px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 5px;
        background: #fff;
        right: 0;
        top: 50px;
        ul {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          li {
            display: block;
            width: 30px;
            height: 30px;
            line-height: 30px;
            border-radius: 50%;
            text-align: center;
            &:hover {
              a:not(.fei) {
                color: #fff;
                background: #2042ab;
                border-color: #2042ab;
              }
            }
            a {
              width: 100%;
              height: 100%;
              display: block;
              border-radius: 50%;
              color: #4a4a4a;
              font-size: 14px;
              &.active {
                background: #2042ab;
                color: #fff;
              }
              &.fei {
                color: #ccc;
                cursor: auto;
              }
            }
            &.last-day {
              width: 100%;
              a {
                display: initial;
                width: auto;
                padding: 6px 12px;
                border-radius: 5px;
                border: 1px solid #cccccc;
                &.active {
                  color: #fff;
                  background: #2042ab;
                  border-color: #2042ab;
                }
              }
            }

            &.placeholder-li {
              border: 0;
              margin: 0;
              padding: 0;
              height: 0;
            }
          }
        }
      }
    }
  }
}
</style>
